import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import userReducer from "./user/reducer";
import storeReducer from "./store/reducer";
import roleReducer from "./role/reducer";
import productReducer from "./product/reducer";
import categoryReducer from "./category/reducer";
import serviceReducer from "./service/reducer";
import providerReducer from "./provider/reducer";
import customerReducer from "./customer/reducer";
import employeeReducer from "./employee/reducer";
import sellReducer from "./sell/reducer";
import reportReducer from "./report/reducer";
import notificationReducer from "./notification/reducer";
import dashboardReducer from "./dashboard/reducer";
import offerReducer from "./offer/reducer";
import quotationReducer from "./quotation/reducer";
import documentTypeReducer from "./document-type/reducer";
import rewardReducer from './reward/reducer';
import newsletterReducer from './newsletter/reducer';
import contactUsReducer from './contactUs/reducer';
import franchiseReducer from './franchise/reducer';

export default combineReducers({
    form: formReducer,
    user: userReducer,
    store: storeReducer,
    role: roleReducer,
    product: productReducer,
    category: categoryReducer,
    service: serviceReducer,
    provider: providerReducer,
    customer: customerReducer,
    employee: employeeReducer,
    sell: sellReducer,
    report: reportReducer,
    notification: notificationReducer,
    dashboard: dashboardReducer,
    offer: offerReducer,
    quotation: quotationReducer,
    documentType: documentTypeReducer,
    reward: rewardReducer,
    newsletter: newsletterReducer,
    contactUs: contactUsReducer,
    franchise: franchiseReducer,
});



// WEBPACK FOOTER //
// ./src/store/index.js